import { render, staticRenderFns } from "./fixed_setting.vue?vue&type=template&id=0f99eeb8"
import script from "./fixed_setting.vue?vue&type=script&lang=js"
export * from "./fixed_setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports